function brandReviewPreview(){
  const node=globalThis.document?.querySelector('[data-casame-brand-reviews-preview]');
  if(!node)return null;
  try{const config=JSON.parse(node.textContent);return /^[a-f\d-]{36}$/i.test(config.store||'')?config:null}catch{return null}
}
const cache=new Map();
export const ratingWord=rating=>rating>=4.5?'Hervorragend':rating>=4?'Sehr gut':rating>=3?'Durchschnittlich':rating>=2?'Ausreichend':'Mangelhaft';
export function parseAggregate(data){
  const a=data?.reviewAggregate;
  if(!a)return null;
  const count=Number(a.reviewCount),total=Number(a.reviewRatingValuesTotal);
  if(!Number.isInteger(count)||count<=0||!Number.isFinite(total)||total<count||total>count*5)return null;
  return {count,rating:total/count};
}
export async function getAggregate(store,fetcher=fetch){
  if(!/^[a-f\d-]{36}$/i.test(store||''))return null;
  const r=await fetcher(`https://api.okendo.io/v1/stores/${store}/review_aggregate`,{credentials:'omit',signal:AbortSignal.timeout(12000)});
  if(!r.ok)throw new Error('Review totals unavailable');
  return parseAggregate(await r.json());
}
export async function connectAggregate(root){
  if(root.dataset.summaryStarted)return;
  root.dataset.summaryStarted='true';
  const preview=brandReviewPreview();
  const store=preview?.store||root.dataset.store;
  if(!cache.has(store))cache.set(store,getAggregate(store).catch(error=>{cache.delete(store);throw error}));
  let stats;try{stats=await cache.get(store)}catch{delete root.dataset.summaryStarted;return}
  if(!stats||!root.isConnected)return;
  const rating=stats.rating.toFixed(1).replace('.',','),count=new Intl.NumberFormat('de-DE').format(stats.count);
  root.querySelectorAll('[data-review-rating]').forEach(el=>el.textContent=rating);
  root.querySelectorAll('[data-review-count]').forEach(el=>el.textContent=count);
  root.querySelectorAll('[data-review-word]').forEach(el=>el.textContent=ratingWord(stats.rating));
  root.querySelectorAll('[data-review-stars]').forEach(el=>{el.style.setProperty('--csr-fill',`${stats.rating/5*100}%`);el.setAttribute('aria-label',`Bewertung: ${rating} von 5`)});
  root.querySelectorAll('[data-review-score-panel]').forEach(el=>el.hidden=false);
  if(preview){
    root.dataset.reviewProvenance='casame-france';
    const hero=root.querySelector('.slideshow__rating-link');
    if(hero){hero.replaceChildren();const n=document.createElement('span');n.dataset.reviewCount='';n.textContent=count;hero.append(n,document.createTextNode(' Bewertungen (FR)'));}
  }
  root.dataset.loaded='true';root.hidden=false;
}
function connectWithin(parent=document){
  if(parent.matches?.('[data-casame-aggregate]'))connectAggregate(parent);
  parent.querySelectorAll('[data-casame-aggregate]').forEach(connectAggregate);
}
if(typeof document!=='undefined'){
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>connectWithin(),{once:true});else connectWithin();
  document.addEventListener('shopify:section:load',e=>connectWithin(e.target));
  document.addEventListener('casame:photo-reviews-loaded',e=>{
    const badge=e.target.closest('.casame-home-reviews')?.querySelector('[data-verified-photos]');
    if(badge)badge.hidden=!e.detail.allVerified;
  });
}
